import { IPaginate, TComment } from 'models/common';
import { useState, useEffect } from 'react';
import dbService from 'services/database.service';

const useComment = (articleId: string) => {
  const [totalCommentCount, setTotalCommentCount] = useState(0);
  const [lastComment, setLastComment] = useState<TComment>()
  const [comments, setComments] = useState<TComment[]>()
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!articleId) {
      return;
    }

    fetchTotalCommentsCount();
  }, [])


  const fetchTotalCommentsCount = async () => {
    const res = await dbService.getComments({
      filter: { article: articleId },
      limit: 1,
      paginate: true,
      relation: true
    });

    const resPaginate = res as unknown as IPaginate<TComment>;
    if (resPaginate) {
      setTotalCommentCount(resPaginate.meta.total);
      setLastComment(resPaginate.data[0]);
    }
  };

  const fetchComments = async () => {
    dbService.getComments({
      filter: {
        article: articleId,
      },
      relation: ['owner', 'likes', 'replies', 'replies.owner', 'replies.likes'],
    }).then(res => setComments(res))
      .finally(() => setLoading(false))

  };

  const handlePostChanged = () => {
    fetchTotalCommentsCount();
  }

  return { totalCommentCount, lastComment, comments, loading, handlePostChanged, fetchComments, setComments };
};

export default useComment;
